<template>
  <div v-if="!hasPermission('List Place')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar/>
    <div class="container-xxl">
      <div class="card">
        <div class="card-body py-4">
          <div class="d-flex flex-wrap flex-sm-nowrap mb-6">
            <div class="flex-grow-1">
              <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center mb-1">
                    <a href="#" class="text-gray-800 text-hover-primary fs-2 fw-bolder me-3">
                      {{ place.place_name }}
                    </a>
                    <span class="badge me-auto" :class="place.active ? 'badge-light-success' : 'badge-light-danger'">
                      {{ place.active ? 'Ativo' : 'Inativo' }}
                    </span>
                  </div>
                  <div class="d-flex flex-wrap fw-bold mb-4 fs-5 text-gray-400">
                    #{{ place.id_place }} {{ place.place_address }}, {{ place.place_addr_numer }}
                  </div>
                </div>
                <div class="d-flex mb-4"></div>
              </div>
              <div class="d-flex flex-wrap justify-content-start">
                <div class="d-flex flex-wrap">
                  <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                    <div class="d-flex align-items-center">
                      <div class="fs-4 fw-bolder">
                        {{ date(place.created_at).format('DD/MM/YYYY h:mm:ss') }}
                      </div>
                    </div>
                    <div class="fw-bold fs-6 text-gray-400">Data de Cadastro</div>
                  </div>
                  <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                    <div class="d-flex align-items-center">
                      <div class="fs-4 fw-bolder counted" data-kt-countup="true"
                           :data-kt-countup-value="place.place_latitude">
                        {{ place.place_latitude ? formatNumber(place.place_latitude) : '' }}
                      </div>
                    </div>
                    <div class="fw-bold fs-6 text-gray-400">Latitude</div>
                  </div>
                  <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                    <div class="d-flex align-items-center">
                      <div class="fs-4 fw-bolder counted" data-kt-countup="true"
                           :data-kt-countup-value="place.place_longitude">
                        {{ place.place_longitude ? formatNumber(place.place_longitude) : '' }}
                      </div>
                    </div>
                    <div class="fw-bold fs-6 text-gray-400">Longitude</div>
                  </div>
                </div>
                <div class="symbol-group symbol-hover mb-3">
                  <div class="symbol symbol-35px symbol-circle" data-bs-toggle="tooltip"
                       :title="user.user_name" v-for="user in users" :data-bs-original-title="user.user_name">
                    <span class="symbol-label bg-ubbi text-inverse-warning fw-bolder">
                      {{ user.user_name.charAt(0).toUpperCase() }}
                    </span>
                  </div>

                  <router-link to="/users" class="symbol symbol-35px symbol-circle">
                    <span class="symbol-label bg-dark text-inverse-dark fs-8 fw-bolder" data-bs-toggle="tooltip"
                          data-bs-trigger="hover" title="Ver todos os usuários" data-bs-original-title="Ver usuários">
                      +
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br>

      <div class="card">
        <div class="card-header">
          <ul class="nav nav-tabs card-header-tabs mt-4" role="tablist">
            <li class="nav-item" role="presentation">
              <button class="nav-link active" id="data-tab" data-bs-toggle="tab" data-bs-target="#data-place"
                      type="button" role="tab" aria-controls="data-place" aria-selected="true">
                Dados Cadastrais
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link" id="locations-tab" data-bs-toggle="tab" data-bs-target="#locations-place"
                      type="button" role="tab" aria-controls="locations-place" aria-selected="false">
                Unidades de Atendimento
              </button>
            </li>
          </ul>
        </div>
        
        <div class="tab-content">
          <!-- Tab Dados Cadastrais -->
          <div class="tab-pane fade show active" id="data-place" role="tabpanel" aria-labelledby="data-tab">
        <form id="kt_project_settings_form" class="form" method="post" @submit.prevent="update">
          <div class="card-body p-9">
            <div class="row mb-5">
              <div class="col-xl-1">
                <div class="fs-6 fw-bold mt-2 mb-3">Logo</div>
              </div>
              <div class="col-lg-8">
                <div class="image-input image-input-circle" data-kt-image-input="true"
                     :class="place.place_logo ? '' : 'image-input-empty'"
                     :style="{backgroundImage: place.place_logo ? '' : `url(${require('@/assets/images/no-photo.png')})`}">

                  <div class="image-input-wrapper w-125px h-125px" v-if="place.place_logo"
                       :style="{backgroundImage: `url(${place.place_logo})`}">
                  </div>

                  <div class="image-input-wrapper w-125px h-125px" style="background-image: none;" v-else></div>

                  <label class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                         data-kt-image-input-action="change" data-bs-toggle="tooltip" title=""
                         data-bs-original-title="Alterar Foto">
                    <i class="bi bi-pencil-fill fs-7"></i>
                    <input type="file" ref="photo" name="photo" id="photo" accept=".png, .jpg, .jpeg"
                           @change="handleFileChange">
                    <input type="hidden" name="avatar_remove">
                  </label>

                  <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="cancel" data-bs-toggle="tooltip" title=""
                        data-bs-original-title="Cancelar" @click="cancelImage">
                <i class="bi bi-x fs-2"></i>
            </span>

                  <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                        data-kt-image-input-action="remove" data-bs-toggle="tooltip" title=""
                        data-bs-original-title="Remover foto" @click="removeImage">
                <i class="bi bi-x fs-2"></i>
            </span>
                </div>
                <div class="form-text">Os formatos permitidos são: png, jpg, jpeg.</div>
              </div>

            </div>
            <div class="row mb-8">
              <div class="col-md-2">
                <div class="mb-10">
                  <label for="place_name" class="required form-label">Nome</label>
                  <input type="text" class="form-control form-control-solid" id="place_name"
                         :class="errors.place_name ? 'is-invalid' : ''"
                         name="place_name" v-model="place.place_name"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_name">
                    {{ errors.place_name.join('\n') }}
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-10">
                  <label for="place_type" class="required form-label">Tipo</label>
                  <select class="form-control form-control-solid" id="place_type"
                          :class="errors.place_type ? 'is-invalid' : ''"
                          v-model="place.place_type" name="place_type">
                    <option :value="key" v-for="(type, key) in placeTypes">
                      {{ type }}
                    </option>
                  </select>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_type">
                    {{ errors.place_type.join('\n') }}
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-10">
                  <label for="place_cnes" class="form-label">Cod. CNES</label>
                  <input type="text" class="form-control form-control-solid" id="place_cnes"
                         :class="errors.place_cnes ? 'is-invalid' : ''"
                         name="place_cnes" v-model="place.place_cnes"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_cnes">
                    {{ errors.place_cnes.join('\n') }}
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-10">
                  <label for="place_phone" class="required form-label">Telefone</label>
                  <input type="text" class="form-control form-control-solid" id="place_phone"
                         :class="errors.place_phone ? 'is-invalid' : ''"
                         name="place_phone" v-model="place.place_phone"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_phone">
                    {{ errors.place_phone.join('\n') }}
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-10">
                  <label for="place_whatsapp" class="form-label">WhatsApp</label>
                  <input type="text" class="form-control form-control-solid" id="place_whatsapp"
                         :class="errors.place_whatsapp ? 'is-invalid' : ''"
                         name="place_whatsapp" v-model="place.place_whatsapp"
                         v-mask="'+## (##) #####-####'" placeholder="+55 (00) 00000-0000"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_whatsapp">
                    {{ errors.place_whatsapp.join('\n') }}
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-10">
                  <label for="place_domain" class="required form-label">Domínio(WebRTC)</label>
                  <input disabled type="text" class="form-control form-control-solid" id="place_domain"
                         :class="errors.place_domain ? 'is-invalid' : ''"
                         name="place_domain" v-model="place.place_domain"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_domain">
                    {{ errors.place_domain.join('\n') }}
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <label class="form-label fw-bolder text-dark fs-6">
                  CEP <span class="text-danger">*</span>
                </label>
                <input class="form-control form-control-lg form-control-solid" type="text" required
                       :class="errors.place_zip_code ? 'is-invalid' : ''" v-model="place.place_zip_code"
                       v-mask="'#####-###'" placeholder="Ex: 00000-000"
                       name="place_zip_code" autocomplete="off" @blur="getZipCode"/>

                <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_zip_code">
                  {{ errors.place_zip_code.join('\n') }}
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-10">
                  <label for="place_address" class="required form-label">Endereço</label>
                  <input type="text" class="form-control form-control-solid" id="place_address"
                         :class="errors.place_address ? 'is-invalid' : ''"
                         name="place_address" v-model="place.place_address"/>
                </div>
              </div>
              <div class="col-md-1">
                <div class="mb-10">
                  <label for="place_addr_numer" class="required form-label">Número</label>
                  <input type="text" class="form-control form-control-solid" id="place_addr_numer"
                         :class="errors.place_addr_numer ? 'is-invalid' : ''"
                         name="place_addr_numer" v-model="place.place_addr_numer"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_addr_numer">
                    {{ errors.place_addr_numer.join('\n') }}
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-10">
                  <label for="place_neighborhood" class="required form-label">Bairro</label>
                  <input type="text" class="form-control form-control-solid" id="place_neighborhood"
                         :class="errors.place_neighborhood ? 'is-invalid' : ''"
                         name="place_neighborhood" v-model="place.place_neighborhood"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_neighborhood">
                    {{ errors.place_neighborhood.join('\n') }}
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="mb-10">
                  <label for="place_addr_compl" class="form-label">Complemento</label>
                  <input type="text" class="form-control form-control-solid" id="place_addr_compl"
                         :class="errors.place_addr_compl ? 'is-invalid' : ''"
                         name="place_addr_compl" v-model="place.place_addr_compl"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_addr_compl">
                    {{ errors.place_addr_compl.join('\n') }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-10">
                  <label for="id_state" class="required form-label">Estado</label>
                  <select class="form-control form-control-solid" id="id_state"
                          @change="getCitiesFromState($event.target.value)"
                          :class="errors.id_state ? 'is-invalid' : ''"
                          name="state" v-model="place.id_state">
                    <option :value="state.id_state" v-for="state in states">
                      {{ state.state_name }}
                    </option>
                  </select>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.id_state">
                    {{ errors.id_state.join('\n') }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-10">
                  <label for="id_city" class="required form-label">Cidade</label>
                  <select class="form-control form-control-solid" id="id_city"
                          :class="errors.id_city ? 'is-invalid' : ''"
                          name="state" v-model="place.id_city">
                    <option :value="city.id_city" v-for="city in citiesFromState">
                      {{ city.city_name }}
                    </option>
                  </select>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.id_city">
                    {{ errors.id_city.join('\n') }}
                  </div>
                </div>
              </div>


              <div class="col-md-1">
                <div class="mb-10">
                  <label for="status" class="required form-label">Status</label>
                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" v-model="place.active" id="status" name="status">
                    <label class="form-check-label fw-bold text-gray-400 ms-3" for="status">Ativo</label>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-10">
                  <label for="status" class="required form-label">Replicar Disponibilidade</label>
                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" v-model="place.unify_avail_default" id="status"
                           name="status">
                    <label class="form-check-label fw-bold text-gray-400 ms-3" for="status">Replicar disponibilidades
                      por padrão</label>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-10">
                  <label for="place_waiting_list_auto_notify" class="required form-label">Lista de espera</label>
                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" v-model="place.place_waiting_list_auto_notify"
                           id="place_waiting_list_auto_notify" name="place_waiting_list_auto_notify">
                    <label class="form-check-label fw-bold text-gray-400 ms-3" for="place_waiting_list_auto_notify">
                      Avisar pacientes automaticamente quando houver horário livre
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-10">
                  <label for="place_documents_whatsapp" class="required form-label">Documentos do atendimento</label>
                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" v-model="place.place_documents_whatsapp"
                           id="place_documents_whatsapp" name="place_documents_whatsapp">
                    <label class="form-check-label fw-bold text-gray-400 ms-3" for="place_documents_whatsapp">
                      Avisar o paciente no WhatsApp quando os documentos ficarem prontos (consome a cota de mensagens)
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-10">
                  <label for="place_color" class="form-label">Cor do Local</label>
                  <input type="color" class="form-control form-control-solid" id="place_color"
                         :class="errors.place_color ? 'is-invalid' : ''"
                         name="place_color" v-model="place.place_color"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_color">
                    {{ errors.place_color.join('\n') }}
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-10">
                  <label for="negotiation_penalty_percent" class="form-label">Multa (%) negociação</label>
                  <input type="number" step="0.01" class="form-control form-control-solid" id="negotiation_penalty_percent"
                         :class="errors.negotiation_penalty_percent ? 'is-invalid' : ''"
                         name="negotiation_penalty_percent" v-model.number="place.negotiation_penalty_percent"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.negotiation_penalty_percent">
                    {{ errors.negotiation_penalty_percent.join('\n') }}
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-10">
                  <label for="negotiation_interest_daily_percent" class="form-label">Juros (%/dia) negociação</label>
                  <input type="number" step="0.0001" class="form-control form-control-solid" id="negotiation_interest_daily_percent"
                         :class="errors.negotiation_interest_daily_percent ? 'is-invalid' : ''"
                         name="negotiation_interest_daily_percent" v-model.number="place.negotiation_interest_daily_percent"/>
                  <div class="fv-plugins-message-container invalid-feedback" v-if="errors.negotiation_interest_daily_percent">
                    {{ errors.negotiation_interest_daily_percent.join('\n') }}
                  </div>
                </div>
              </div>

              <div class="col-xl-4">
                <label class="form-label fw-bolder text-dark fs-6">
                  Tipo de Chave PIX<span class="text-danger">*</span>
                </label>
                <Dropdown v-model="place.place_pix_key_type" :options="pix_key_types"
                          optionLabel="name" optionValue="id"
                          class="form-control form-control-solid form-control-sm"
                          :class="errors.place_pix_key_type ? 'is-invalid' : ''"
                          @change="maskPIXKey($event.value)"
                          :filter="true" placeholder="Tipo de Chave" style="display: flex;"/>
                <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_pix_key_type">
                  {{ errors.place_pix_key_type.join('\n') }}
                </div>
              </div>
              <div class="col-xl-8">
                <label class="form-label fw-bolder text-dark fs-6">
                  Chave PIX <span class="text-danger">*</span>
                </label>
                <input v-if="pix_key_mask" class="form-control form-control-lg form-control-solid" type="text"
                       required
                       v-mask="pix_key_mask"
                       v-model="place.place_pix_key"
                       placeholder="Informe sua Chave PIX para recebimentos"
                       name="place_pix_key" autocomplete="off"/>

                <input v-if="!pix_key_mask" class="form-control form-control-lg form-control-solid" type="text"
                       required
                       v-model="place.place_pix_key"
                       :class="errors.place_pix_key ? 'is-invalid' : ''"
                       placeholder="Informe sua Chave PIX para recebimentos"
                       name="place_pix_key" autocomplete="off"/>
                <div class="fv-plugins-message-container invalid-feedback" v-if="errors.place_pix_key">
                  {{ errors.place_pix_key.join('\n') }}
                </div>
              </div>

              <div class="col-md-12 mt-5">
                <div class="mb-10">
                  <label for="id_city" class="required form-label">Termo da teleconsulta</label>
                  <QuillEditor
                    height="500"
                    required="true" :value="place.term_teleconsultation"
                    class="form-control-solid" :options="{'placeholder': 'Digite aqui... '}"
                    @change="place.term_teleconsultation = $event.html"/>

                </div>
              </div>


            </div>
          </div>
          <div class="card-footer d-flex justify-content-end py-6 px-9">
            <button v-if="hasPermission('Store Place')" type="submit" class="btn btn-primary"
                    id="kt_project_settings_submit">Salvar
            </button>
          </div>
        </form>
          </div>
          
          <div class="tab-pane fade" id="locations-place" role="tabpanel" aria-labelledby="locations-tab">
            <div class="card-body p-9">
              <div class="d-flex justify-content-between align-items-center mb-5">
                <h3 class="fs-3 fw-bolder mb-0">Unidades de Atendimento</h3>
                <button type="button" class="btn btn-primary" @click="openLocationModal(null)">
                  <i class="bi bi-plus-circle me-2"></i>Nova Unidade
                </button>
              </div>
              
              <div v-if="locations.length === 0" class="text-center py-10">
                <p class="text-muted mb-5">Nenhuma unidade de atendimento cadastrada.</p>
                <img :src="require('@/assets/images/no_data-cuate.svg')" alt="Sem dados" class="h-200px mb-5">
              </div>
              
              <div v-else class="table-responsive">
                <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                  <thead>
                    <tr class="fw-bolder text-muted">
                      <th class="min-w-150px">Nome</th>
                      <th class="min-w-200px">Endereço</th>
                      <th class="min-w-100px">Cidade</th>
                      <th class="min-w-80px text-center">Status</th>
                      <th class="min-w-100px text-end">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="location in locations" :key="location.id_place_location">
                      <td>
                        <span class="text-gray-800 fw-bold">{{ location.location_name }}</span>
                        <span v-if="location.location_nickname" class="text-gray-500 ms-2 fs-7">
                          ({{ location.location_nickname }})
                        </span>
                      </td>
                      <td>
                        <span class="text-gray-600">{{ location.location_full_address || `${location.location_address}, ${location.location_addr_numer}` }}</span>
                      </td>
                      <td>
                        <span class="text-gray-600">{{ location.city?.city_name || '-' }}</span>
                      </td>
                      <td class="text-center">
                        <span :class="location.active ? 'badge badge-success' : 'badge badge-danger'">
                          {{ location.active ? 'Ativo' : 'Inativo' }}
                        </span>
                      </td>
                      <td class="text-end">
                        <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                @click="openLocationModal(location)" title="Editar">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button type="button" class="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                                @click="deleteLocation(location)" title="Excluir">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Location -->
  <div class="modal fade" id="locationModal" tabindex="-1" aria-labelledby="locationModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="locationModalLabel">
            {{ editingLocation ? 'Editar' : 'Nova' }} Unidade de Atendimento
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="saveLocation">
          <div class="modal-body">
            <div class="row mb-5">
              <div class="col-md-6">
                <div class="mb-5">
                  <label for="location_name" class="required form-label">Nome da Unidade</label>
                  <input type="text" class="form-control form-control-solid" 
                         id="location_name"
                         v-model="locationForm.location_name" 
                         placeholder="Ex: Unidade Centro, Unidade Zona Sul"
                         required>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-5">
                  <label for="location_nickname" class="form-label">Apelido</label>
                  <input type="text" class="form-control form-control-solid" 
                         id="location_nickname"
                         v-model="locationForm.location_nickname" 
                         placeholder="Ex: Centro, Zona Sul, Matriz"
                         maxlength="50">
                  <div class="form-text">Nome curto/apelido para identificação rápida da unidade</div>
                </div>
              </div>
            </div>
            
            <div class="row mb-5">
              <div class="col-md-4">
                <div class="mb-5">
                  <label for="location_zip_code" class="form-label">CEP</label>
                  <input type="text" class="form-control form-control-solid" 
                         id="location_zip_code"
                         v-model="locationForm.location_zip_code"
                         v-mask="'#####-###'"
                         @blur="getLocationZipCode"
                         placeholder="00000-000">
                </div>
              </div>
              <div class="col-md-8">
                <div class="mb-5">
                  <label for="location_address" class="required form-label">Endereço</label>
                  <input type="text" class="form-control form-control-solid" 
                         id="location_address"
                         v-model="locationForm.location_address" 
                         placeholder="Rua, Avenida, etc."
                         required>
                </div>
              </div>
            </div>
            
            <div class="row mb-5">
              <div class="col-md-2">
                <div class="mb-5">
                  <label for="location_addr_numer" class="form-label">Número</label>
                  <input type="text" class="form-control form-control-solid" 
                         id="location_addr_numer"
                         v-model="locationForm.location_addr_numer" 
                         placeholder="123">
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-5">
                  <label for="location_addr_compl" class="form-label">Complemento</label>
                  <input type="text" class="form-control form-control-solid" 
                         id="location_addr_compl"
                         v-model="locationForm.location_addr_compl" 
                         placeholder="Apto, Sala, etc.">
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-5">
                  <label for="location_neighborhood" class="form-label">Bairro</label>
                  <input type="text" class="form-control form-control-solid" 
                         id="location_neighborhood"
                         v-model="locationForm.location_neighborhood" 
                         placeholder="Bairro">
                </div>
              </div>
            </div>
            
            <div class="row mb-5">
              <div class="col-md-4">
                <div class="mb-5">
                  <label for="location_id_state" class="required form-label">Estado</label>
                  <select class="form-control form-control-solid" 
                          id="location_id_state"
                          v-model="locationForm.id_state" 
                          @change="getLocationCitiesFromState"
                          required>
                    <option value="">Selecione</option>
                    <option v-for="state in states" :key="state.id_state" :value="state.id_state">
                      {{ state.state_name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-5">
                  <label for="location_id_city" class="required form-label">Cidade</label>
                  <select class="form-control form-control-solid" 
                          id="location_id_city"
                          v-model="locationForm.id_city" 
                          required>
                    <option value="">Selecione</option>
                    <option v-for="city in locationCitiesFromState" :key="city.id_city" :value="city.id_city">
                      {{ city.city_name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-5">
                  <label for="location_phone" class="form-label">Telefone</label>
                  <input type="text" class="form-control form-control-solid" 
                         id="location_phone"
                         v-model="locationForm.location_phone"
                         v-mask="'(##) #####-####'"
                         placeholder="(00) 00000-0000">
                  <div class="form-text">Opcional. Se não informado, será usado o telefone do Place.</div>
                </div>
              </div>
            </div>
            
            <div class="row mb-5">
              <div class="col-md-12">
                <div class="mb-5">
                  <label for="location_active" class="form-label">Status</label>
                  <div class="form-check form-switch form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" v-model="locationForm.active" id="location_active">
                    <label class="form-check-label fw-bold text-gray-400 ms-3" for="location_active">Ativo</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import {mask} from "vue-the-mask";
import strMask from "../../helpers/strMask";
import Alert from "../../helpers/alert";
import Dropdown from 'primevue/dropdown';
import Permission from "../../helpers/permission";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import QuillEditor from "vue-quill-editor/src/editor.vue";

export default {
  name: "Place",
  directives: {
    mask,
  },
  components: {
    Dropdown,
    Toolbar,
    QuillEditor,
  },
  data() {
    return {
      errors: [],
      submitted: false,
      placeTypes: [],
      states: [],
      citiesFromState: [],
      users: [],
      place: {},
      pix_key_types: [],
      pix_key_mask: '',
      locations: [],
      editingLocation: null,
      locationForm: {
        location_name: '',
        location_nickname: '',
        location_address: '',
        location_addr_numer: '',
        location_addr_compl: '',
        location_neighborhood: '',
        location_zip_code: '',
        id_city: '',
        id_state: '',
        location_phone: '',
        active: true,
      },
      locationCitiesFromState: [],
    }
  },
  computed: {
    currentPlace() {
      return this.$store.state.auth.place;
    }
  },
  created() {
    this.getUsersFromPlace();
    this.getStates();
    this.getPlaceTypes();
    this.getPixKeyTypes();
  },
  async mounted() {

    if (this.currentPlace.id_state) {
      await this.getCitiesFromState(this.currentPlace.id_state).then((response) => {
        this.citiesFromState = response.data;
      });
    }

    this.maskPIXKey(this.currentPlace.place_pix_key_type);

    this.place = {
      "id_place": this.currentPlace.id_place,
      "place_name": this.currentPlace.place_name,
      "place_address": this.currentPlace.place_address,
      "place_addr_numer": this.currentPlace.place_addr_numer,
      "place_addr_compl": this.currentPlace.place_addr_compl,
      "place_neighborhood": this.currentPlace.place_neighborhood,
      "place_phone": this.currentPlace.place_phone,
      "place_whatsapp": this.currentPlace.place_whatsapp,
      "place_logo": this.currentPlace.place_logo,
      "place_latitude": this.currentPlace.place_latitude,
      "place_longitude": this.currentPlace.place_longitude,
      "id_city": this.currentPlace.id_city,
      "active": this.currentPlace.active,
      "term_teleconsultation": this.currentPlace.term_teleconsultation,
      "place_type": this.currentPlace.place_type,
      "place_domain": this.currentPlace.place_domain,
      "id_add_policy": this.currentPlace.id_add_policy,
      "created_at": this.currentPlace.created_at,
      "id_state": this.currentPlace.id_state,
      "place_zip_code": this.currentPlace.place_zip_code,
      "place_pix_key_type": this.currentPlace.place_pix_key_type,
      "place_pix_key": this.currentPlace.place_pix_key,
      "unify_avail_default": this.currentPlace.unify_avail_default,
      "place_waiting_list_auto_notify": this.currentPlace.place_waiting_list_auto_notify ?? true,
      "place_documents_whatsapp": this.currentPlace.place_documents_whatsapp ?? false,
      "place_cnes": this.currentPlace.place_cnes,
      "place_color": this.currentPlace.place_color,
      "negotiation_penalty_percent": this.currentPlace.negotiation_penalty_percent ?? 0,
      "negotiation_interest_daily_percent": this.currentPlace.negotiation_interest_daily_percent ?? 0,
    };

    this.loadLocations();
    KTImageInput.createInstances();
  },
  methods: {
    date: moment,
    maskIt(value, mask) {
      return strMask.it(value, mask);
    },
    getUsersFromPlace() {
      http.get(`/places/${this.currentPlace.id_place}/users`).then((response) => {
        this.users = response.data;
      });
    },
    getPlaceTypes() {
      http.get(`/place-types`).then((response) => {
        this.placeTypes = response.data;
      });
    },
    getStates() {
      http.get(`/states`).then((response) => {
        this.states = response.data;
      });
    },
    getCitiesFromState(stateId) {
      return http.get(`/states/${stateId}/cities`).then((response) => {
        this.citiesFromState = response.data;

        return response;
      });
    },
    getPixKeyTypes() {
      http.get(`/pixkeytypes`).then((response) => {
        this.pix_key_types = response.data;
      });
    },
    maskPIXKey(keyPixType) {
      switch (keyPixType) {
        case 'CPF':
          this.pix_key_mask = '###.###.###-##';
          break;
        case 'CNPJ':
          this.pix_key_mask = '##.###.###/####-##';
          break;
        case 'PHONE':
          this.pix_key_mask = '(##) #####-####';
          break;
        case 'EMAIL':
          this.pix_key_mask = ''
          break;
        default:
          this.pix_key_mask = '';
          break;
      }
    },
    update() {
      http.put(`/places/${this.place.id_place}`, this.place).then((response) => {
        Alert.toastSuccess("Local de atendimento atualizado com sucesso.");
        this.errors = [];
        this.$store.dispatch('auth/selectPlace', response.data);
      }).catch((error) => {
        if (error.response.data?.errors) {
          this.errors = error.response.data.errors;
        } else {
          Alert.toastError(error.response.data)
        }
      });
    },
    handleFileChange() {
      const file = this.$refs.photo.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.place.place_logo = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    cancelImage() {
      this.$refs.photo.value = null;
      this.place.place_logo = null;
    },
    removeImage() {
      this.place.place_logo = null;
    },
    formatNumber(value) {
      return parseFloat(value).toFixed(6);
    },
    getZipCode() {
      http.get(`zipcode/` + this.place.place_zip_code).then((response) => {
        console.log(response.data);
        this.place.place_address = response.data.address;
        this.place.place_neighborhood = response.data.neighborhood;
        this.place.id_state = response.data.state?.id_state;
        this.getCitiesFromState(this.place.id_state);
        this.place.id_city = response.data.city?.id_city;
      }).catch((e) => {
        console.log(e.response)
      });
    },
    hasPermission(permission) {
      return Permission.has(permission);
    },
    loadLocations() {
      const placeId = this.place?.id_place || this.currentPlace?.id_place;
      if (!placeId) {
        return;
      }
      http.get(`/places/${placeId}/locations`).then((response) => {
        this.locations = response.data || [];
      }).catch(() => {
        this.locations = [];
      });
    },
    openLocationModal(location) {
      this.editingLocation = location;
      if (location) {
        this.locationForm = {
          location_name: location.location_name || '',
          location_nickname: location.location_nickname || '',
          location_address: location.location_address || '',
          location_addr_numer: location.location_addr_numer || '',
          location_addr_compl: location.location_addr_compl || '',
          location_neighborhood: location.location_neighborhood || '',
          location_zip_code: location.location_zip_code || '',
          id_city: location.id_city || '',
          id_state: location.city?.id_state || '',
          location_phone: location.location_phone || '',
          active: location.active !== undefined ? location.active : true,
        };
        if (this.locationForm.id_state) {
          this.getLocationCitiesFromState();
        }
      } else {
        this.locationForm = {
          location_name: '',
          location_nickname: '',
          location_address: '',
          location_addr_numer: '',
          location_addr_compl: '',
          location_neighborhood: '',
          location_zip_code: '',
          id_city: '',
          id_state: '',
          location_phone: '',
          active: true,
        };
        this.locationCitiesFromState = [];
      }
      const modal = new bootstrap.Modal(document.getElementById('locationModal'));
      modal.show();
    },
    saveLocation() {
      const url = this.editingLocation
        ? `/places/${this.place.id_place}/locations/${this.editingLocation.id_place_location}`
        : `/places/${this.place.id_place}/locations`;
      
      const method = this.editingLocation ? 'put' : 'post';
      
      http[method](url, this.locationForm).then((response) => {
        Alert.toastSuccess(`Unidade de atendimento ${this.editingLocation ? 'atualizada' : 'cadastrada'} com sucesso.`);
        const modal = bootstrap.Modal.getInstance(document.getElementById('locationModal'));
        modal.hide();
        this.loadLocations();
      }).catch((error) => {
        Alert.toastError(error.response?.data?.message || 'Erro ao salvar unidade de atendimento.');
      });
    },
    async deleteLocation(location) {
      const result = await Swal.fire({
        title: 'Excluir Unidade',
        text: `Tem certeza que deseja excluir a unidade "${location.location_nickname || location.location_name}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      });

      if (!result.isConfirmed) {
        return;
      }
      
      http.delete(`/places/${this.place.id_place}/locations/${location.id_place_location}`).then(() => {
        Alert.toastSuccess('Unidade de atendimento excluída com sucesso.');
        this.loadLocations();
      }).catch((error) => {
        Alert.toastError(error.response?.data?.message || 'Erro ao excluir unidade de atendimento.');
      });
    },
    getLocationZipCode() {
      if (!this.locationForm.location_zip_code || this.locationForm.location_zip_code.length < 8) {
        return;
      }
      const zipCode = this.locationForm.location_zip_code.replace(/\D/g, '');
      http.get(`zipcode/${zipCode}`).then((response) => {
        this.locationForm.location_address = response.data.address || '';
        this.locationForm.location_neighborhood = response.data.neighborhood || '';
        if (response.data.state?.id_state) {
          this.locationForm.id_state = response.data.state.id_state;
          this.getLocationCitiesFromState().then(() => {
            if (response.data.city?.id_city) {
              this.locationForm.id_city = response.data.city.id_city;
            }
          });
        }
      }).catch(() => {
        // Ignora erro de CEP
      });
    },
    getLocationCitiesFromState() {
      if (!this.locationForm.id_state) {
        this.locationCitiesFromState = [];
        return Promise.resolve();
      }
      return http.get(`/states/${this.locationForm.id_state}/cities`).then((response) => {
        this.locationCitiesFromState = response.data;
        return response;
      });
    },
  },
}
</script>

<style scoped>

</style>